import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Gift,
  FileText,
  MessageCircle,
  CircleCheck,
  Leaf,
  ArrowRight,
  Heart,
} from "lucide-react";
import { useShop } from "../context/ShopContext";
import { pharmacistImg, whyChoose } from "../mock";

const RightRail = () => {
  const navigate = useNavigate();
  const { setModal } = useShop();

  return (
    <div className="space-y-3.5">
      {/* Offer card */}
      <div className="bg-[#e9f7ee] rounded-xl p-4 hover:shadow-md transition-shadow">
        <div className="flex items-start gap-3">
          <Gift size={30} className="text-[#12a150] shrink-0 mt-0.5" strokeWidth={1.7} />
          <div>
            <div className="text-[15px] font-bold text-[#0e7a3d] leading-tight">
              Flat 15% OFF
              <br />
              on First Order
            </div>
            <div className="text-[11px] text-gray-500 mt-1">Use Code: WELCOME15</div>
          </div>
        </div>
        <button
          onClick={() => navigate("/offers")}
          className="mt-3 flex items-center gap-1.5 bg-[#12a150] hover:bg-[#0d8a40] text-white text-[12px] font-semibold rounded-full px-4 py-1.5 transition-colors"
        >
          Shop Now <ArrowRight size={13} />
        </button>
      </div>

      {/* Upload prescription card */}
      <div className="bg-[#eaf3fd] rounded-xl p-4 hover:shadow-md transition-shadow">
        <div className="flex items-start gap-3">
          <FileText size={30} className="text-[#1d7ed0] shrink-0 mt-0.5" strokeWidth={1.7} />
          <div>
            <div className="text-[15px] font-bold text-[#0b5fa5] leading-tight">
              Upload Prescription
            </div>
            <div className="text-[11px] text-gray-500 mt-1 leading-snug">
              Get genuine medicines with expert verification
            </div>
          </div>
        </div>
        <button
          onClick={() => setModal("upload")}
          className="mt-3 flex items-center gap-1.5 bg-[#12a150] hover:bg-[#0d8a40] text-white text-[12px] font-semibold rounded-full px-4 py-1.5 transition-colors"
        >
          Upload Now <ArrowRight size={13} />
        </button>
      </div>

      {/* Need help card */}
      <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow">
        <div className="flex items-center gap-3">
          <img
            src={pharmacistImg}
            alt="Pharmacist"
            className="w-14 h-14 rounded-full object-cover ring-2 ring-green-100"
          />
          <div>
            <div className="text-[14.5px] font-bold text-gray-800">Need Help?</div>
            <div className="text-[11px] text-gray-500 leading-snug">
              Our pharmacist is here for you 24/7
            </div>
          </div>
        </div>
        <button
          onClick={() => window.dispatchEvent(new Event("open-chat"))}
          className="mt-3 w-full flex items-center justify-center gap-1.5 bg-[#12a150] hover:bg-[#0d8a40] text-white text-[12px] font-semibold rounded-full py-2 transition-colors"
        >
          <MessageCircle size={14} /> Chat Now
        </button>
      </div>

      {/* Why choose */}
      <div className="bg-white border border-gray-100 rounded-xl p-4 shadow-sm">
        <div className="text-[14.5px] font-bold text-gray-800 mb-3">
          Why Choose ArogyaMeds?
        </div>
        <div className="space-y-3">
          {whyChoose.map((w) => (
            <div key={w.title} className="flex items-start gap-2.5">
              <CircleCheck size={18} className="text-[#12a150] shrink-0 mt-0.5" />
              <div>
                <div className="text-[12.5px] font-semibold text-gray-800 leading-tight">
                  {w.title}
                </div>
                <div className="text-[10.5px] text-gray-400">{w.sub}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Quote card */}
      <div className="bg-[#eef8ef] rounded-xl p-4 flex items-center gap-2.5">
        <Leaf size={22} className="text-[#12a150] shrink-0" />
        <div className="text-[15px] font-bold text-[#0e7a3d] italic">
          Stay Healthy
          <br />
          Stay Happy <Heart size={13} className="inline text-[#e31837] fill-[#e31837]" />
        </div>
      </div>
    </div>
  );
};

export default RightRail;
